import { render, staticRenderFns } from "./ruku_do.vue?vue&type=template&id=6c25974e&scoped=true"
import script from "./ruku_do.vue?vue&type=script&lang=js"
export * from "./ruku_do.vue?vue&type=script&lang=js"
import style0 from "./ruku_do.vue?vue&type=style&index=0&id=6c25974e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c25974e",
  null
  
)

export default component.exports